import {
  getCardPaymentReadinessReason,
  type ApiError,
  type CardPaymentReadinessReason,
} from "@bw/shared/api"

export type PaymentReadinessAction = {
  href: string
  label: string
}

const READINESS_ACTIONS: Record<
  CardPaymentReadinessReason,
  PaymentReadinessAction
> = {
  facility_not_found: {
    href: "/settings/facility",
    label: "Review facility setup",
  },
  stripe_connect_missing: {
    href: "/setup/stripe",
    label: "Finish payment setup",
  },
  stripe_onboarding_incomplete: {
    href: "/setup/stripe",
    label: "Finish payment setup",
  },
  commission_rate_missing: {
    href: "/settings/contract",
    label: "Review contract terms",
  },
  contract_terms_not_accepted: {
    href: "/settings/contract",
    label: "Review contract terms",
  },
  commission_rate_invalid: {
    href: "/settings/contract",
    label: "Review contract terms",
  },
  organization_inactive: {
    href: "/getting-started",
    label: "Review organization status",
  },
  payment_routing_unavailable: {
    href: "/getting-started",
    label: "Review business setup",
  },
}

export function paymentReadinessAction(
  error: ApiError,
): PaymentReadinessAction {
  const reason =
    getCardPaymentReadinessReason(error) ?? "payment_routing_unavailable"
  return READINESS_ACTIONS[reason]
}
